import { WlCache } from './cache';

import { IconRegistry } from './registry/icons/IconRegistry';

import {
  ComponentRegistry,
} from './registry/components/ComponentRegistry';


import { getWlConfig, WlConfig } from 'config/wls/wlConfig';

export async function preloadWl(
  wlId: number
): Promise<void> {
  const config = getWlConfig(wlId);

  if (!config) {
    await IconRegistry.initializeDefault();

    return;
  }

  try {
    await IconRegistry.initialize(
      config.iconLibrary
    );

    if (config.components) {
      await Promise.allSettled(
        Object.entries(config.components).map(
          async ([name, componentConfig]) => {
            let runtimeComponent;

          
            ComponentRegistry.register(name, {
              component: componentConfig.component ?? undefined,
              props: componentConfig.props ?? {},
              layout: componentConfig.layout ?? {},
            });
          }
        )
      );
    }

    cacheWlResources(wlId, config);
  } catch (error) {
    console.error(
      '[WL preload] failed',
      error
    );
  }
}

function cacheWlResources(
  wlId: number,
  config: WlConfig
) {
  WlCache.set(
    `wl-${wlId}`,
    {
      activeIconPack:
        IconRegistry.getActivePack(),

      components:
        ComponentRegistry.getAll(),
    },
    config.version
  );
}